var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Route"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5884 13.463C15.319 12.2056 15.7156 10.7196 15.7156 9.21069C15.7156 4.79832 12.4384 1.20898 8.40967 1.20898C4.38098 1.20898 1.10376 4.79832 1.10376 9.21069C1.10376 10.7196 1.50037 12.2056 2.23096 13.463L8.40967 24.2082L14.5884 13.463ZM5.27856 9.21069C5.27856 7.31284 6.67685 5.78139 8.40967 5.78139C10.1422 5.78139 11.5408 7.31284 11.5408 9.21069C11.5408 11.1082 10.1422 12.64 8.40967 12.64C6.67685 12.64 5.27856 11.1082 5.27856 9.21069Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.45337 9.21048C9.45337 8.57004 8.99428 8.06738 8.40967 8.06738C7.82492 8.06738 7.36597 8.57004 7.36597 9.21048C7.36597 9.85077 7.82492 10.3536 8.40967 10.3536C8.99428 10.3536 9.45337 9.85077 9.45337 9.21048Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.5103 21.7847C28.6296 21.7847 26.2917 24.3452 26.2917 27.5002C26.2917 28.5744 26.5631 29.6263 27.085 30.5408L31.5103 38.2225L35.9355 30.5408C36.4574 29.6263 36.7288 28.5744 36.7288 27.5002C36.7288 24.3452 34.3909 21.7847 31.5103 21.7847ZM32.554 28.6433H30.4666V26.3571H32.554V28.6433Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.5103 17.6468L35.9355 9.96514C36.4574 9.05066 36.7288 7.9987 36.7288 6.92449C36.7288 3.76953 34.3909 1.20898 31.5103 1.20898C28.6296 1.20898 26.2917 3.76953 26.2917 6.92449C26.2917 7.9987 26.5631 9.05066 27.085 9.96529L31.5103 17.6468ZM30.4666 5.78139H32.554V8.06759H30.4666V5.78139Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.986 33.1396L10.3369 34.5568C10.7961 35.1972 11.318 35.8145 11.8816 36.3632L13.2802 34.6714C12.8209 34.1913 12.3617 33.6883 11.986 33.1396Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.52295 25.3662H7.43555C7.43555 26.1892 7.49831 27.012 7.62341 27.8353L9.69008 27.4467C9.58571 26.7608 9.52295 26.0521 9.52295 25.3662Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.1492 29.4814L8.18701 30.236C8.41663 31.0132 8.72974 31.7676 9.08459 32.4992L10.9215 31.402C10.6084 30.7846 10.3579 30.1444 10.1492 29.4814Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.6768 37.8718C14.303 38.3064 14.9709 38.718 15.6598 39.038L16.4739 36.9347C15.9103 36.6604 15.3258 36.3175 14.804 35.9517L13.6768 37.8718Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.8096 39.8153C18.5404 39.9982 19.2919 40.1353 20.0434 40.1811L20.1895 37.9177C19.5424 37.8488 18.9162 37.7574 18.29 37.5977L17.8096 39.8153Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.1934 37.9404H24.2738V40.2266H22.1934V37.9404Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.3682 37.9404H28.4486V40.2266H26.3682V37.9404Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M27.2659 14.9258H29.3533V17.212H27.2659V14.9258Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.0911 14.9258H25.1785V17.212H23.0911V14.9258Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M14.7415 14.9258H16.8289V17.212H14.7415V14.9258Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.9163 14.9258H21.0037V17.212H18.9163V14.9258Z",
    fill: "#57B8EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/Route.bb0c9b858c5a51486d9939b964a5af71.svg";
export { ForwardRef as ReactComponent };